import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-left, margin, padding"><path d="M7.75 3.75L20.25 3.75L20.25 20.25H7.75L7.75 3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 3V21" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLayoutLeft;
